<section class="h5 d-flex flex-column flex-md-column flex-lg-row flex-xl-row gap-2">
    <strong class="mb-2">Step 5:</strong>
    <span class="fw-normal">Personal Info</span>
</section>
<p class="text-muted mb-3">
    On <em class="fw-medium">{{ deliveryDayText() }}</em> a member of our dedicated delivery team will drop your order
    at your doorstep. Here is the team!
</p>

<section class="mb-3 d-flex driver-cards" (mousedown)="onMouseDown($event)" (mousemove)="onMouseMove($event)"
    (mouseup)="onMouseUp($event)" (mouseleave)="onMouseUp($event)" (touchstart)="onTouchStart($event)"
    (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd($event)">
    @for (driver of driversPlaceHolders(); track $index) {
    <div class=" col-2 px-2 driver-card">
        <div class="d-flex align-items-center gap-2 rounded-3 py-2 px-3">
            <img src="{{ driver.image }}" class="rounded-circle" style="width:48px;height:48px;object-fit:cover;"
                [alt]="driver.name">
            <div class="d-flex flex-column">
                <span class="h7-regular text-nowrap">{{ driver.name }}</span>
                <span class="h8-regular text-muted">{{ driver.expertise }}</span>
            </div>
        </div>
    </div>
    }
</section>

<div class="d-flex align-items-center gap-3 mb-2">
    <p class="text-muted mb-0">
        <strong>Now let's make this official!</strong> Tell us a little more about you so we can welcome you
        into the Philly Foodworks family.
    </p>
</div>

<form [formGroup]="svc.personalForm" class="row g-3" novalidate>
    <div class="row g-3 animated fadeInUp">
        <div class="col-12 col-md-6 col-xl-6">
            <label class="form-label small fw-semibold">FIRST NAME*</label>
            <input type="text" class="form-control" formControlName="firstName" placeholder="First Name"
                [class.is-invalid]="invalid('firstName')" [class.is-valid]="valid('firstName')">
            <div class="invalid-feedback" *ngIf="invalid('firstName')">First Name is required</div>
        </div>

        <div class="col-12 col-md-6 col-xl-6">
            <label class="form-label small fw-bold">LAST NAME*</label>
            <input type="text" class="form-control" formControlName="lastName" [class.is-invalid]="invalid('lastName')"
                placeholder="Last Name" [class.is-valid]="valid('lastName')">
            <div class="invalid-feedback" *ngIf="invalid('lastName')">Last Name is required</div>
        </div>
    </div>

    <div class="row g-3 animated fadeInUp">
        <div class="col-12 col-md-6 col-xl-6">
            <label class="form-label small fw-semibold">EMAIL* <i class="fas fa-info-circle text-primary"></i></label>
            <input type="email" class="form-control" [value]="svc.addressForm.value.email" readonly>
        </div>
        <div class="col-12 col-md-6 col-xl-6">
            <label class="form-label small fw-semibold">PHONE NUMBER*</label>
            <input type="tel" class="form-control" formControlName="phone" placeholder="(xxx) xxx - xxxx"
                [class.is-invalid]="invalid('phone')" [class.is-valid]="valid('phone')" appOnlyNumber>
            <div class="invalid-feedback" *ngIf="invalid('phone')">Phone Number is required</div>
        </div>
    </div>

    <div class="row g-3 animated fadeInUp">
        <div class="col-12 col-md-6 col-xl-6">
            <section class="d-flex align-items-center justify-content-start gap-3">
                <label class="form-label small fw-semibold">PASSWORD*</label>
                <button type="button" class="mb-2 p-0 btn btn-sm btn-link text-decoration-none"
                    (click)="togglePwd('main')" tabindex="-1">
                    @if (showPwd) {
                    <i class="fas fa-eye-slash"></i>
                    } @else {
                    <i class="fas fa-eye"></i>
                    }
                </button>
            </section>
            <div class="position-relative">
                <input [type]="showPwd ? 'text' : 'password'" class="form-control" formControlName="password"
                    placeholder="Enter your password" [class.is-invalid]="invalid('password')"
                    [class.is-valid]="valid('password')">

            </div>
            <ng-container *ngIf="touched('password')">
                <ng-container *ngIf="svc.personalForm.get('password')?.errors as errs">
                    <div class="invalid-feedback d-block" *ngIf="errs['required']">Password is required.</div>
                    <div class="invalid-feedback d-block" *ngIf="errs['minLength']">Minimum 8 characters.</div>
                    <div class="invalid-feedback d-block" *ngIf="errs['requiredUpper']">At least one uppercase letter.
                    </div>
                    <div class="invalid-feedback d-block" *ngIf="errs['requiredLower']">At least one lowercase letter.
                    </div>
                    <div class="invalid-feedback d-block" *ngIf="errs['requiredNumber']">At least one number.</div>
                    <div class="invalid-feedback d-block" *ngIf="errs['requiredSpecial']">At least one special
                        character.
                    </div>
                    <div class="invalid-feedback d-block" *ngIf="errs['noWhitespace']">No whitespace allowed.</div>
                </ng-container>
            </ng-container>
        </div>
        <div class="col-12 col-md-6 col-xl-6">
            <section class="d-flex align-items-center justify-content-start gap-3">
                <label class="form-label small fw-semibold">RE-ENTER PASSWORD*</label>
                <button type="button" class="mb-2 p-0 btn btn-sm btn-link text-decoration-none"
                    (click)="togglePwd('confirm')" tabindex="-1">
                    @if (showPwd2) {
                    <i class="fas fa-eye-slash"></i>
                    } @else {
                    <i class="fas fa-eye"></i>
                    }
                </button>
            </section>
            <div class="position-relative">
                <input [type]="showPwd2 ? 'text' : 'password'" class="form-control" formControlName="password2"
                    placeholder="Re-enter your password"
                    [class.is-invalid]="invalid('password2') || !svc.passwordsMatch() && touched('password2')"
                    [class.is-valid]="valid('password2') && svc.passwordsMatch()">
            </div>
            <div class="invalid-feedback d-block" *ngIf="!svc.passwordsMatch() && touched('password2')">
                Passwords must match.
            </div>
        </div>
    </div>

    <div class="row g-3 animated fadeInUp">
        <div class="col-12 col-md-6 col-xl-6">
            <label class="form-label small fw-semibold">HOW DID YOU HEAR ABOUT US?*</label>
            <select class="form-select" formControlName="howHeardSource">
                <option [ngValue]="null">Select a source</option>
                <option *ngFor="let s of howHeardSources()" [ngValue]="s.id">{{ s.name }}</option>
            </select>
        </div>
        <div class="col-12 col-md-6 col-xl-6" *ngIf="howHeardSourceRequiresDetails()">
            <label class="form-label small fw-semibold">TELL US MORE - WHERE DID YOU FIND US?*</label>
            <input type="text" class="form-control" formControlName="howHeardDetails"
                placeholder="Provide additional details" [class.is-invalid]="invalid('howHeardDetails')"
                [class.is-valid]="valid('howHeardDetails')">
            <div class="invalid-feedback" *ngIf="invalid('howHeardDetails')">Details are required</div>
        </div>
    </div>

    <!--  <div class="col-md-12">
        <mat-slide-toggle formControlName="addAnotherUser" color="primary">Add another user to this
            account</mat-slide-toggle>
    </div> -->

    <!-- Campos del segundo usuario - solo se muestran si addAnotherUser está activo -->
    <div class="col-12" *ngIf="svc.personalForm.get('addAnotherUser')?.value">
        <div class="border-top pt-4 mt-4">
            <h6 class="mb-3 text-primary"><strong>Second User Information</strong></h6>

            <div class="row g-3 animated fadeInUp">
                <div class="col-12 col-md-6 col-xl-6">
                    <label class="form-label small fw-semibold">FIRST NAME*</label>
                    <input type="text" class="form-control" formControlName="secondUserFirstName"
                        placeholder="First Name" [class.is-invalid]="invalid('secondUserFirstName')"
                        [class.is-valid]="valid('secondUserFirstName')">
                    <div class="invalid-feedback" *ngIf="invalid('secondUserFirstName')">First Name is required</div>
                </div>

                <div class="col-12 col-md-6 col-xl-6">
                    <label class="form-label small fw-bold">LAST NAME*</label>
                    <input type="text" class="form-control" formControlName="secondUserLastName"
                        [class.is-invalid]="invalid('secondUserLastName')" placeholder="Last Name"
                        [class.is-valid]="valid('secondUserLastName')">
                    <div class="invalid-feedback" *ngIf="invalid('secondUserLastName')">Last Name is required</div>
                </div>
            </div>

            <div class="row g-3 animated fadeInUp mt-3">
                <div class="col-12 col-md-6 col-xl-6">
                    <label class="form-label small fw-semibold">EMAIL*</label>
                    <input type="email" class="form-control" formControlName="secondUserEmail"
                        placeholder="Email address" [class.is-invalid]="invalid('secondUserEmail')"
                        [class.is-valid]="valid('secondUserEmail')">
                    <div class="invalid-feedback" *ngIf="invalid('secondUserEmail')">
                        <span *ngIf="svc.personalForm.get('secondUserEmail')?.errors?.['required']">Email is
                            required</span>
                        <span *ngIf="svc.personalForm.get('secondUserEmail')?.errors?.['email']">Please enter a valid
                            email</span>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-xl-6">
                    <label class="form-label small fw-semibold">PHONE NUMBER*</label>
                    <input type="tel" class="form-control" formControlName="secondUserPhone"
                        placeholder="(xxx) xxx - xxxx" [class.is-invalid]="invalid('secondUserPhone')"
                        [class.is-valid]="valid('secondUserPhone')" appOnlyNumber>
                    <div class="invalid-feedback" *ngIf="invalid('secondUserPhone')">Phone Number is required</div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-md-12">
        <mat-checkbox formControlName="optInSms" color="primary" (change)="cdRef.markForCheck()">
            Yes, send me text messages about local products and producers.
        </mat-checkbox>
    </div>
    <div class="col-md-12 m-0">
        <mat-checkbox formControlName="optInMarketing" color="primary" (change)="cdRef.markForCheck()">
            Yes, send emails about local products and producers.
        </mat-checkbox>
    </div>

    <!-- Botón para continuar -->
    <div class="col-12 d-flex justify-content-center mt-4">
        <button type="button" class="btn btn-primary px-4" [disabled]="!svc.canProceed('personal')" (click)="onNext()">
            Next <span class="ms-1">→</span>
        </button>
    </div>
</form>